import { TUserAction } from '../../apis/__shared/shared.interfaces';

export const mockUserAction: TUserAction = {
  userId: '123',
  timestamp: 1629876543,
  name: 'Vikram Singh',
  email: 'vikram.singh@example.com',
};
